module.exports = __webpack_public_path__ + "calltracking-police.5fb64f43edd10e930bc751809039d2da.png";